module.exports = __webpack_public_path__ + "assets/img/NFT.a911d970.png";